var exports = {
  "verySatisfied": "verySatisfied__51JGef",
  "good": "good__zGPmsl",
  "satisfied": "satisfied__VyEOdP",
  "dissatisfied": "dissatisfied__4KlE9B",
  "veryDissatisfied": "veryDissatisfied__G8mQrw",
  "bad": "bad__IHVT9s",
};

__webpack_require__.r(module.exports = exports);
